import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';
import { injectIntl } from 'react-intl';

@injectIntl
export default class ChartModal extends React.Component {
  render() {
    const { intl } = this.props;
    const { props } = this;

    const data = {
      labels: Object.keys(props.data[this.props.entry]),
      datasets: [
        {
          label: this.props.label, // "", {//intl.formatMessage({id: this.props.entry})},
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(75,192,192,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: Object.values(props.data[this.props.entry]),
        },
      ],
    };

    if (
      this.props.showSecondPlot &&
      this.props.title === 'Monthly active startups'
    ) {
      data.datasets.push({
        label: 'Average Monthly Startups',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(0,0,0,0.5)',
        borderCapStyle: 'butt',
        borderDash: [10, 5],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(0,0,0,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: Object.keys(props.data[this.props.entry]).map(
          el => props.data['avg_monthly'],
        ),
      });
    }

    const array = Object.values(props.data[this.props.entry]);

    return (
      <div className="container-fluid">
        <div style={{ cursor: 'pointer' }} onClick={props.openModal}>
          <div className={'bold text-center'}>{this.props.title}</div>
          <h6 className={'text-center'}>
            {intl.formatMessage({ id: 'last_registered_value_label' })}
            {array[array.length - 1].toFixed(2)}{' '}
          </h6>
          <Line data={data} />
        </div>

        <Modal
          show={this.props.active}
          onHide={props.handleHide}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Header>
            <Modal.Title>{this.props.title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Line data={data} />

            {this.props.description}
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.props.closeModal}>
              {intl.formatMessage({ id: 'close_modal' })}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
